import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { useFeatures } from "./hooks/usePermissions";
import { filterEsgParamsForPlan } from "./utils/features";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import _ from "lodash";
import FormData from "form-data";
import { BlobServiceClient } from "@azure/storage-blob";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";
import Dropzone from "react-dropzone";
import { Avatar, Backdrop, Badge, Box, Button, CircularProgress, Paper, Select, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material";
import CloudUploadTwoToneIcon from "@mui/icons-material/CloudUploadTwoTone";
import clsx from "clsx";
import containerTheme from "./theme/containerTheme.js";
import AADHeader from "./components/AADHeader.js";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Modal from "react-bootstrap/Modal";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { RadioButton } from "primereact/radiobutton";
import { disambiguateSourceLabel } from "./utils/sourceLabelDisplay";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Icon1 = "./assets/img/Assets/configration_icon/White/1.png";
const Icon2 = "./assets/img/Assets/configration_icon/White/2.png";
const Icon3 = "./assets/img/Assets/configration_icon/White/3.png";
const Icon4 = "./assets/img/Assets/configration_icon/White/4.png";
const Icon5 = "./assets/img/Assets/configration_icon/White/5.png";
const customIcons = [Icon1, Icon2, Icon3, Icon4, Icon5];

const iconDotInactive = "./assets/img/Assets/configration_icon/Teal Green/Ellipse 61.png";
const iconBackgroundInactive = "./assets/img/Assets/configration_icon/Teal Green/Ellipse 59.png";
const steps = [
  {
    label: "Select ESG Parameter",
    description: ``,
    active: 1,
  },
  {
    label: "Choose data connector",
    description: "",
    active: 2,
  },
  {
    label: "Create connection",
    description: "",
    active: 3,
  },
  {
    label: "Map fields",
    description: "",
    active: 4,
  },
  {
    label: "Review and finish",
    description: "",
    active: 5,
  },
];

export default function VerticalLinearStepper(props) {
  // const classes = useStyles(props);
  const navigate = useNavigate();
  // Plan drives which ESG parameters a trial may configure (staff/loading = full list).
  const { plan: _rawPlan, staff: _staff, loading: _planLoading } = useFeatures();
  const orgPlan = _staff || _planLoading ? "standard" : _rawPlan;
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const isOptionDisabled = (option) => {
    return selectedOptions.includes(option);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [count, setCount] = useState(1);
  const [activeStep, setActiveStep] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [myloading, setMyLoading] = React.useState(false);
  const [apiDone, setApiDone] = React.useState(false);
  const [result, setResult] = React.useState({});
  const [selectedExcel, setSelectedExcel] = useState("");
  const [showTable, setShowTable] = React.useState(false);
  const [businessunit, setBusinessUnit] = React.useState(false);
  const [modules, setModules] = React.useState(false);
  const [mymodule, setMyModule] = useState("");
  const [importfile, setImportFile] = React.useState("");
  const [importpdffile, setImportPDFFile] = React.useState("");
  const [azureAPIMessage, setAzureAPIMessage] = React.useState("");
  const [excelfields, setFields] = React.useState([]);
  const [headerfields, setHeaderFields] = React.useState([]);
  const [pdffields, setPDFFields] = React.useState([]);
  const [pdfSourceLabels, setPdfSourceLabels] = React.useState({});
  const [apifields, setAPIFields] = React.useState([]);
  const [dynamicsfields, setDynamicsFields] = React.useState([]);
  const [azureTableStoragefields, setAzureTableStorageFields] = React.useState([]);
  const [pattern, setPattern] = useState("");
  const [sitelocation, setSiteLocation] = useState("");
  const [activeSiteLocation, setActiveSiteLocation] = useState([]);
  const [sitelocation1, setSiteLocation1] = useState("");
  const [leftheader, setLeftHeader] = useState([]);
  const [rightheader, setRightHeader] = useState([]);
  const [connectors, setConnectors] = useState([]);
  const [matrics, setMatrics] = useState("");
  const [mymatrics, setMyMatrics] = useState("");
  const [getappnames, setAppNames] = useState("");
  const [apikey, setApiKey] = useState("");
  const [apivalue, setApiValue] = useState("");
  const [resource, setResource] = useState("");
  const [accesstokenurl, setAccessTokenUrl] = useState("");
  const [clientid, setClientID] = useState("");
  const [clientsecret, setClientSecret] = useState("");
  const [scope, setScope] = useState("");
  const [tenantid, setTenantID] = useState("");
  const [query, setQuery] = useState("");
  const [accountname, setAccoutName] = useState("");
  const [tablename, setTableName] = useState("");
  const [apiclientid, setApiClientId] = useState("");
  const [apisubclientid, setApiSubClientId] = useState("");
  const [hash, setHash] = useState("");
  const companyid = localStorage.getItem("companyid");
  const [selectedConnectors, setSelectedConnectors] = useState([]);
  const [esg, setESG] = useState("");
  const [esgParameter, setESGParameter] = useState("");
  const [topic, setTopic] = useState("");
  const [subTopic, setSubTopic] = useState("");
  const [listESGParameter, setListESGParameter] = useState([]);
  const esgParamOptions = filterEsgParamsForPlan(listESGParameter || [], orgPlan).map((item) => ({ label: item, value: item }));
  const [listESG, setListESG] = useState([]);
  const esgOptions = listESG?.map((item) => ({ label: item, value: item }));
  const [listTopic, setListTopic] = useState([]);
  const topicOptions = listTopic?.map((item) => ({ label: item, value: item }));
  const [listSubTopic, setListSubTopic] = useState([]);
  const subTopicOptions = listSubTopic?.map((item) => ({ label: item, value: item }));
  const [selectedDiv, setSelectedDiv] = useState(null);
  const [parameterOption, setParameterOption] = useState(null); // 'site' or 'legal'
  const [legalEntity, setLegalEntity] = useState("");
  const [listLegalEntity, setListLegalEntity] = useState([]);

  const legalEntityOptions = listLegalEntity?.map((item) => ({
    label: item.name,
    value: item.name,
  }));

  const frequencyOptions = [
    { label: "Weekly", value: "Weekly" },
    { label: "Monthly", value: "Monthly" },
  ];
  const [dataFrequency, setDataFrequency] = useState(null);
  const siteLocationOptions = activeSiteLocation?.map((site) => ({
    label: site.name,
    value: site.name,
  }));
  const [formData, setFormData] = useState({
    connectionType: "",
    accountName: "",
    query: "",
    storageAccountName: "",
    tableName: "",
    key: "",
    value: "",
    resourceUrl: "",
    accessTokenURL: "",
    clientId: "",
    clientSecret: "",
    scope: "",
    tenantId: "",
    message: "",
  });
  const [connectorNames, setConnectorNames] = useState({});
  const [currentDefaultRow, setCurrentDefaultRow] = useState(null);
  const [currentDefaultRowIndex, setCurrentDefaultRowIndex] = useState(null);
  const [defaultValue, setDefaultValue] = useState("");
  const [defaultValues, setDefaultValues] = useState({});
  const [excelFiles, setExcelFiles] = useState([]);
  const [pdfFiles, setPdfFiles] = useState([]); // Store PDF files with blob info
  const [individualExcelHeaders, setIndividualExcelHeaders] = useState({}); // Store headers for each Excel file separately
  const [showAddForm, setShowAddForm] = useState(true);
  const [smartMappingSuggestions, setSmartMappingSuggestions] = useState(null); // Store smart mapping suggestions for PDF fields
  const [connectorNameErrors, setConnectorNameErrors] = useState({});
  const [isFileUploading, setIsFileUploading] = useState(false); // Track if file upload is in progress 
  const cardStyles = {
    heading: {
      marginLeft: "15px",
      marginBottom: "10px",
    },
  };

  const allFieldOptions = [
    ...(Array.isArray(headerfields) && headerfields.length ? [{ label: "Excel Headers", items: headerfields.map((h) => ({ label: h, value: h })) }] : []),
    ...(Array.isArray(azureTableStoragefields) && azureTableStoragefields.length ? [{ label: "Azure Table Headers", items: azureTableStoragefields.map((h) => ({ label: h, value: h })) }] : []),
    ...(Array.isArray(pdffields) && pdffields.length ? [{ label: "PDF Fields", items: pdffields.map((h) => ({ label: disambiguateSourceLabel(h, pdfSourceLabels, pdffields), value: h })) }] : []),
  ];

  // Validate connector name function
  const validateConnectorName = (name, connectorType = null) => {
    if (!name || name.trim() === "") {
      return "Connector name is required";
    }

    if (name.length < 3) {
      return "Connector name must be at least 3 characters long";
    }

    if (name.length > 50) {
      return "Connector name cannot exceed 50 characters";
    }

    if (!/^[a-zA-Z0-9\s\-_]+$/.test(name)) {
      return "Connector name can only contain letters, numbers, spaces, hyphens, and underscores";
    }
    // Check for duplicates (case-insensitive)
    const existingNames = [
      ...excelFiles.map((file) => file.connectorName),
      ...pdfFiles.map((file) => file.connectorName),
      ...Object.entries(connectorNames)
        .filter(([key, value]) => key !== connectorType && value && value.trim() !== "")
        .map(([key, value]) => value),
    ].filter(Boolean);

    const isDuplicate = existingNames.some((existingName) => existingName.toLowerCase() === name.toLowerCase());

    if (isDuplicate) {
      return "Connector name must be unique (case-insensitive)";
    }

    return null; // No error
  };

  // Replace your existing validateRequiredFields() with this implementation:
  const validateRequiredFields = () => {
    // Check all required fields have a connector selected
    const invalidFields = excelfields.reduce((acc, field, idx) => {
      if (field.value === true && (!selectedConnectors[idx] || selectedConnectors[idx] === "")) {
        acc.push(field.key);
      }
      return acc;
    }, []);

    if (invalidFields.length > 0) {
      Swal.fire({
                    width: 400,
                    heightAuto: false,
        icon: "error",
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        title: "Required Fields Missing",
        text: `Please select connectors for: ${invalidFields.join(", ")}`,
      });
      return false;
    }

    return true;
  };

  const handleNext = () => {
    setSelectedDiv(null);
    setCount((prevCount) => prevCount + 1);
    if (activeStep === 0) {
      console.log("activeStep: ", activeStep);
    }
    if (activeStep === 1) {
      fetchFields();
      console.log("fetchfields: ", excelfields);
    }
    if (activeStep === 2) {
      // For Excel connector, check if files are uploaded
      if (selectedExcel.includes("Excel")) {
        if (!excelFiles || excelFiles.length === 0) {
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Excel Files Required",
            text: "Please upload at least one Excel file.",
          });
          return false;
        }
      }

      // For PDF connector, check if files are uploaded
      if (selectedExcel.includes("PDF")) {
        if (!pdfFiles || pdfFiles.length === 0) {
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "PDF Files Required",
            text: "Please upload at least one PDF file.",
          });
          return false;
        }
      }

      // Validate that ALL selected connectors have proper names
      const missingNames = [];

      // Check Excel files - each uploaded file should have had a connector name
      if (selectedExcel.includes("Excel")) {
        const excelWithoutNames = excelFiles.filter((file) => !file.connectorName || file.connectorName.trim() === "");
        if (excelWithoutNames.length > 0) {
          missingNames.push("Excel (some files missing connector names)");
        }
      }

      // Check PDF files - each uploaded file should have had a connector name
      if (selectedExcel.includes("PDF")) {
        const pdfWithoutNames = pdfFiles.filter((file) => !file.connectorName || file.connectorName.trim() === "");
        if (pdfWithoutNames.length > 0) {
          missingNames.push("PDF (some files missing connector names)");
        }
      }

      // Check other connectors
      const otherConnectors = selectedExcel.filter((connector) => connector !== "Excel" && connector !== "PDF");
      const otherMissingNames = otherConnectors.filter((connectorType) => !connectorNames[connectorType] || connectorNames[connectorType].trim() === "");
      missingNames.push(...otherMissingNames);

      if (missingNames.length > 0) {
        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Connector Names Required",
          text: `Please provide valid connector names for: ${missingNames.join(", ")}`,
        });
        return false;
      }

      // Validate connector name format (no special characters, reasonable length)
      const allConnectorNames = [
        ...excelFiles.map((file) => file.connectorName), 
        ...pdfFiles.map((file) => file.connectorName),
        ...otherConnectors.map((connector) => connectorNames[connector])
      ].filter((name) => name && name.trim() !== "");

      console.log("Debug - All connector names:", allConnectorNames);
      console.log("Debug - Excel files:", excelFiles);
      console.log("Debug - PDF files:", pdfFiles);
      console.log("Debug - Other connectors:", otherConnectors);
      console.log("Debug - ConnectorNames object:", connectorNames);

      const invalidNames = allConnectorNames.filter((name) => {
        // Check length (3-50 characters)
        if (name.length < 3 || name.length > 50) return true;
        // Check for valid characters (alphanumeric, spaces, hyphens, underscores only)
        if (!/^[a-zA-Z0-9\s\-_]+$/.test(name)) return true;
        return false;
      });

      if (invalidNames.length > 0) {
        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Invalid Connector Names",
          text: `Connector names must be 3-50 characters long and contain only letters, numbers, spaces, hyphens, and underscores. Invalid names: ${invalidNames.join(", ")}`,
        });
        return false;
      }

      // Check for duplicate connector names (case-insensitive)
      const lowerCaseNames = allConnectorNames.map((name) => name.toLowerCase());
      const duplicateNames = [];
      const seenNames = new Set();

      allConnectorNames.forEach((name, index) => {
        const lowerName = name.toLowerCase();
        if (seenNames.has(lowerName)) {
          duplicateNames.push(name);
        } else {
          seenNames.add(lowerName);
        }
      });

      if (duplicateNames.length > 0) {
        // Find all instances of duplicated names for better error message
        const duplicatedGroups = {};
        allConnectorNames.forEach((name) => {
          const lowerName = name.toLowerCase();
          const count = lowerCaseNames.filter((n) => n === lowerName).length;
          if (count > 1) {
            if (!duplicatedGroups[lowerName]) {
              duplicatedGroups[lowerName] = [];
            }
            duplicatedGroups[lowerName].push(name);
          }
        });

        const duplicateGroupsText = Object.values(duplicatedGroups)
          .map((group) => `"${group.join('", "')}"`)
          .join(", ");

        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Duplicate Connector Names",
          text: `Each connector must have a unique name (case-insensitive). Duplicate groups found: ${duplicateGroupsText}`,
        });
        return false;
      }
    }
    if (activeStep === 3) {
      // New validation logic for required fields
      const farray = [];
      for (let i = 0; i < excelfields.length; i++) {
        const field = excelfields[i];
        const isRequired = field.value === true;
        const fieldName = field.key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase());
        const selectedValue = selectedOptions[i];
        const hasDefaultValue = defaultValues[i] && defaultValues[i].trim() !== "";
        
        // Field is valid if it has either a selected option OR a default value
        if (isRequired && (!selectedValue || selectedValue === "") && !hasDefaultValue) {
          farray.push(fieldName);
        }
      }
      if (farray.length > 0) {
        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Required Fields Missing",
          text: "Please map or add default values for: " + farray.join(", "),
        });
        return false;
      }
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    console.log("Neeraj activeStep: ", activeStep);
  };

  const handleBackConfig = () => {
    setShowTable(false);
  };

  const handleBack = () => {
    setSelectedDiv(null);
    setCount((prevCount) => prevCount - 1);
    const currentstep = activeStep;
    if (currentstep === 2) {
      // Going back to ESG metric selection — clear upload + all mapping state
      // so switching to a different metric starts fresh
      setImportFile("");
      setFields([]);
      setSelectedOptions([]);
      setSelectedConnectors([]);
    }
    if (currentstep === 3) {
      // Going back to file upload — clear mapping selections
      setSelectedOptions([]);
      setSelectedConnectors([]);
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  const [personName, setPersonName] = React.useState([]);

  const username = localStorage.getItem("userName");
  var myHeaders = new Headers();
  myHeaders.append("username", username);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const handleESGChange = (value, setMyModule) => {
    if (value == "") {
      setMyMatrics("");
      setMatrics("");
      setMyModule("");
    } else {
      setMyModule(value);
      fetchESGMatrics(value);
    }
  };

  async function checkAppName1(site) {
    console.log(site);
    if (matrics !== "" && site !== "") {
      var CHeaders = new Headers();
      CHeaders.append("username", username);
      CHeaders.append("esg", matrics);
      CHeaders.append("site", site);

      var Options = {
        method: "GET",
        headers: CHeaders,
        redirect: "follow",
      };

      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-allappname`, Options);
        if (response.status === 200) {
          const responseJson = await response.json();
          if (responseJson.success == false) {
          } else if (responseJson.status == 400) {
          } else {
            var data = responseJson.data;
            setAppNames(data);
          }
        } else {
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function checkAppName2(matrics) {
    if (topic !== "" && sitelocation1 !== "") {
      var CHeaders = new Headers();
      CHeaders.append("username", username);
      CHeaders.append("esg", topic);
      CHeaders.append("site", sitelocation1);

      var Options = {
        method: "GET",
        headers: CHeaders,
        redirect: "follow",
      };

      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-allappname`, Options);
        if (response.status === 200) {
          const responseJson = await response.json();
          if (responseJson.success == false) {
          } else if (responseJson.status == 400) {
          } else {
            var data = responseJson.data;
            setAppNames(data);
          }
        } else {
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function fetchSiteLocation() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-sitelocation`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setSiteLocation("");
        } else if (responseJson.status == 400) {
          setSiteLocation("");
        } else {
          setSiteLocation(responseJson);
          setActiveSiteLocation(responseJson.data.filter((item) => item.isActive === true));
        }
      } else {
        setSiteLocation("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchLegalEntities() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-entities`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setListLegalEntity("");
        } else if (responseJson.status == 400) {
          setListLegalEntity("");
        } else {
          setListLegalEntity(responseJson.data.filter((item) => item.isActive === true));
        }
      } else {
        setListLegalEntity("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchESG() {
    const username = localStorage.getItem("userName");
    const myHeaders = new Headers();
    myHeaders.append("username", username);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        esg: [""],
        esgParameter: [""],
        topic: [""],
        subTopic: [""],
      }), // Add body here, pass any needed data
      redirect: "follow",
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-configuration-parameter`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false || responseJson.status === 400) {
          setListESG("");
        } else {
          setListESG(responseJson.esg);
        }
      } else {
        setListESG("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchESGParameter(e) {
    const username = localStorage.getItem("userName");
    const myHeaders = new Headers();
    myHeaders.append("username", username);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        esg: [e],
        esgParameter: [""],
        topic: [""],
        subTopic: [""],
      }), // Add body here, pass any needed data
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-configuration-parameter`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false || responseJson.status === 400) {
          setLoading(false);
          setListESGParameter("");
        } else {
          setLoading(false);
          setListESGParameter(responseJson.esgParameter);
        }
      } else {
        setLoading(false);
        setListESGParameter("");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  async function fetchTopic(e) {
    const username = localStorage.getItem("userName");
    const myHeaders = new Headers();
    myHeaders.append("username", username);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        esg: [esg],
        esgParameter: [e],
        topic: [""],
        subTopic: [""],
      }), // Add body here, pass any needed data
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-configuration-parameter`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false || responseJson.status === 400) {
          setLoading(false);
          setListTopic("");
        } else {
          setLoading(false);
          setListTopic(responseJson.topic);
        }
      } else {
        setLoading(false);
        setListTopic("");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  async function fetchSubTopic(e) {
    const username = localStorage.getItem("userName");
    const myHeaders = new Headers();
    myHeaders.append("username", username);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        esg: [esg],
        esgParameter: [esgParameter],
        topic: [e],
        subTopic: [""],
      }), // Add body here, pass any needed data
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-configuration-parameter`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false || responseJson.status === 400) {
          setLoading(false);
          setListSubTopic("");
        } else {
          setLoading(false);
          setListSubTopic(responseJson.subTopic);
        }
      } else {
        setLoading(false);
        setListSubTopic("");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  async function fetchESGMatrics(value) {
    try {
      var myHeaderss = new Headers();
      myHeaderss.append("username", username);
      myHeaderss.append("param", value);
      var requestOptionss = {
        method: "GET",
        headers: myHeaderss,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}ESG`, requestOptionss);
      const data = await response.json();
      setMyMatrics(data);
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchOrganization() {
    try {
      var myHeaderss = new Headers();
      myHeaderss.append("username", username);
      var requestOptionss = {
        method: "GET",
        headers: myHeaderss,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}organization-name`, requestOptionss);
      const data = await response.json();
      setApiClientId("Ecoprism");
      setApiSubClientId(data.data.name);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchESG();
    fetchSiteLocation();
    fetchLegalEntities();
    fetchOrganization();
  }, [activeStep]);

  async function fetchModules() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-modules`);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setModules("");
        } else if (responseJson.status == 400) {
          setModules("");
        } else {
          setModules(responseJson.data);
        }
      } else {
        setModules("");
      }
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    fetchModules();
  }, []);

  async function fetchFields() {
    try {
      var myH = new Headers();
      myH.append("username", username);
      myH.append("modulename", mymodule);
      myH.append("pattern", selectedExcel);
      myH.append("ESGMetric", topic);
      var requestO = {
        method: "GET",
        headers: myH,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-fields`, requestO);
      const data = await response.json();
      const inputList = data.data;
      setFields(inputList);
      function combine(collections) {
        const entries = [...Object.entries(collections)];
        const length = entries[0]?.[1]?.length ?? 0;
        const result = [];
        for (const [name, array] of entries) {
          if (array.length !== length) throw new Error("Non-uniform array lengths");
          for (let i = 0; i < length; i += 1) {
            const item = (result[i] ??= {});
            item[name] = array[i];
          }
        }
        return result;
      }
      const values = Object.values(inputList);
      const keys = Object.keys(inputList);
      const merged = combine({
        value: values,
        key: keys,
      });
      setFields(merged);

      // Smart mapping is now called after PDF upload in onDrop callback
      // and applied when transitioning to step 3 via useEffect
    } catch (error) {
      console.error(error);
    }
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  async function uploadFileName(filename, esgMetric) {
    setMyLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetPdfParameterAsync`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fileName: filename,
          esgMetric: esgMetric,
          userEmail: username,
        }),
      });
      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson.success == false) {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: responseJson.data,
          });
          return { success: false };
        } else if (responseJson.status == 400) {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: responseJson.title,
          });
          return { success: false };
        } else {
          // Extract PDF field names from response.
          // Backend returns { extractedData: {...}, fieldMappingMetadata: { dtoKey: { sourceField: "Billing Period", ... } } }
          const extractedData = responseJson.data?.extractedData ?? responseJson.data;
          const businessUnitKeys = Object.keys(extractedData || {});
          setPDFFields(businessUnitKeys);
          const fmm = responseJson.data?.fieldMappingMetadata;
          const sourceMapping = {};
          if (fmm) Object.entries(fmm).forEach(([k, v]) => { if (v?.sourceField) sourceMapping[k] = v.sourceField; });
          setPdfSourceLabels(sourceMapping);
          setMyLoading(false);

          // Show success modal and wait for user to click OK
          await Swal.fire({
            icon: "success",
            text: filename + " uploaded successfully",
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          });

          // Set import file after modal is dismissed (shows inline indicator)
          setImportPDFFile(filename);
          return { success: true, fields: businessUnitKeys };
        }
      } else {
        setMyLoading(false);
        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Oops...",
          text: "PDF extraction failed",
        });
        return { success: false };
      }
    } catch (error) {
      console.error("PDF extraction error:", error);
      setMyLoading(false);
      Swal.fire({
        icon: "error",
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        title: "Oops...",
        text: "PDF extraction failed",
      });
      return { success: false };
    }
  }

  // Apply smart field mapping with connector selection for PDF fields
  function applySmartFieldMappingWithConnector(smartMappings, destinationFields) {
    if (!smartMappings || !destinationFields || destinationFields.length === 0) return;

    const newSelectedOptions = [...selectedOptions];
    const newSelectedConnectors = [...selectedConnectors];
    const pdfConnectorValue = pdfFiles.length === 1 ? "PDF" : (pdfFiles[0]?.connectorName || "PDF");

    destinationFields.forEach((destField, index) => {
      const destKey = destField.key || destField;
      if (smartMappings[destKey]) {
        newSelectedOptions[index] = smartMappings[destKey];
        newSelectedConnectors[index] = pdfConnectorValue;
      }
    });

    setSelectedOptions(newSelectedOptions);
    setSelectedConnectors(newSelectedConnectors);
  }

  // Apply smart mapping when transitioning to step 3 (Map Fields)
  useEffect(() => {
    if (activeStep === 3 && smartMappingSuggestions && excelfields.length > 0 && selectedExcel.includes("PDF")) {
      applySmartFieldMappingWithConnector(smartMappingSuggestions, excelfields);
      setSmartMappingSuggestions(null);
    }
  }, [activeStep, excelfields, smartMappingSuggestions]);

  //PDF Code
  async function uploadImage(containerName, file) {
    let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, {
      method: "GET",
    });
    if (res.status === 200) {
      const responseJson = await res.json();
      const connectionString = responseJson.data;
      const blobServiceClient = new BlobServiceClient(connectionString);
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlobClient(file.name);
      const blockBlobClient = blobClient.getBlockBlobClient();
      const result = await blockBlobClient.uploadBrowserData(file, {
        blockSize: 4 * 1024 * 1024,
        concurrency: 20,
        onProgress: (ev) => console.log(ev),
      });
      if (result) {
        console.log(file.name);
        uploadFileName(file.name, topic);
      }
    } else {
    }
  }

  // Excel and PDF upload to blob storage
  async function uploadFileToBlobStorage(file, fileType) {
    try {
      setMyLoading(true);
      
      // Get SAS token for blob storage
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, {
        method: "GET",
      });
      
      if (res.status === 200) {
        const responseJson = await res.json();
        const connectionString = responseJson.data;
        const blobServiceClient = new BlobServiceClient(connectionString);
        
        let folderName = "";
        if (parameterOption === "site" && sitelocation1) {
          folderName = sitelocation1; // Site location dropdown value
        } else if (parameterOption === "legal" && legalEntity) {
          folderName = legalEntity; // Legal entity dropdown value
        }
        
        // Container name and blob path
        const containerName = "ecoprismfilecontainer";
        const blobPath = `${companyid}/Configuration/${folderName}/${file.name}`;
        
        const containerClient = blobServiceClient.getContainerClient(containerName);
        const blobClient = containerClient.getBlobClient(blobPath);
        const blockBlobClient = blobClient.getBlockBlobClient();
        const result = await blockBlobClient.uploadBrowserData(file, {
          blockSize: 4 * 1024 * 1024,
          concurrency: 20,
          onProgress: (ev) => console.log(ev),
        });
        if (result) {
          console.log(`${fileType} file uploaded to blob storage:`);
          return {
            success: true,
            fileName: '',
            originalFileName: file.name,
            blobUrl: blobClient.url
          };
        }
      } else {
        throw new Error('Failed to get SAS token');
      }
    } catch (error) {
      console.error(`Error uploading ${fileType} file to blob storage:`, error);
      setMyLoading(false);
      Swal.fire({
        icon: "error",
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        title: "Upload Failed",
        text: `Failed to upload ${fileType} file to storage. Please try again.`,
      });
      return { success: false, error: error.message };
    }
  }

  const onDrop = useCallback(
    async (acceptedFiles, expectedType) => {
      setMyLoading(true);
      const allowedExtensions = {
        Excel: ["xls", "xlsx"],
        PDF: ["pdf"]
      };

      for (const file of acceptedFiles) {
        const extension = file.name.split(".").pop().toLowerCase();
        const fileType = extension === "pdf" ? "PDF" : "Excel";
        const normalizedType = (expectedType || "").toLowerCase() === "pdf" ? "PDF" : "Excel";
        const allowedExts = allowedExtensions[normalizedType];

        if (allowedExts && allowedExts.includes(extension)) {
          // Validate connector name before processing file
          const currentConnectorName = connectorNames[fileType];
          const nameError = validateConnectorName(currentConnectorName, fileType);

          if (nameError) {
            setMyLoading(false);
            Swal.fire({
              icon: "error",
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
              title: "Invalid Connector Name",
              text: nameError,
            });
            return;
          }

          try {
            // First upload to blob storage
            const uploadResult = await uploadFileToBlobStorage(file, fileType);
            
            if (!uploadResult.success) {
              setMyLoading(false);
              return;
            }

            if (fileType === "Excel") {
              // Process Excel file for headers
              const reader = new FileReader();
              reader.onload = (evt) => {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: "binary" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws, { raw: true });
                
                if (data.length === 0) {
                  setMyLoading(false);
                  Swal.fire({ 
                    icon: "error", 
                    title: "Oops...", 
                    text: "Excel File is not proper or header is not present" 
                  });
                  return;
                }

                setImportFile(file.name);
                const fileId = Date.now() + Math.random();
                setExcelFiles((prev) => [
                  ...prev,
                  {
                    connectorName: currentConnectorName,
                    fileName: file.name,
                    blobFileName: uploadResult.fileName,
                    blobUrl: uploadResult.blobUrl,
                    id: fileId, // unique identifier
                  },
                ]);

                // Extract headers from Excel file and store them individually
                const headers = Object.keys(data[0] || {});
                setIndividualExcelHeaders((prev) => ({
                  ...prev,
                  [currentConnectorName]: headers,
                }));

                // Also set general headerfields for backwards compatibility
                setHeaderFields((prevHeaders) => {
                  const combinedHeaders = [...new Set([...prevHeaders, ...headers])];
                  return combinedHeaders;
                });

                // Clear the connector name input for next file
                setConnectorNames((prev) => ({
                  ...prev,
                  ["Excel"]: "",
                }));

                // Clear any validation errors
                setConnectorNameErrors((prev) => ({
                  ...prev,
                  ["Excel"]: null,
                }));

                // Hide the add form after successful upload
                setShowAddForm(false);

                setMyLoading(false);
                Swal.fire({
                  icon: "success",
                  text: `${file.name} uploaded successfully as "${currentConnectorName}"`,
                  iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
                });
              };
              reader.readAsBinaryString(file);
              
            } else if (fileType === "PDF") {
              // Process PDF file - call GetPdfParameterAsync API to extract fields
              // Wait for field extraction to complete before adding to state
              const extractResult = await uploadFileName(file.name, topic);

              if (extractResult.success) {
                // Only add to pdfFiles after successful extraction
                const pdfFileInfo = {
                  connectorName: currentConnectorName,
                  fileName: file.name,
                  blobFileName: uploadResult.fileName,
                  blobUrl: uploadResult.blobUrl,
                  uploadedAt: new Date().toISOString(),
                  id: Date.now() + Math.random()
                };

                // Store PDF file in state
                setPdfFiles((prev) => [...prev, pdfFileInfo]);

                // Build field mapping suggestions client-side from extracted PDF fields.
                // LLM extracts using exact DTO field names (temperature=0, prompt-enforced),
                // so source keys always match destination keys — no server round-trip needed.
                if (extractResult.fields && extractResult.fields.length > 0) {
                  const suggestions = {};
                  extractResult.fields.forEach((field) => { suggestions[field] = field; });
                  setSmartMappingSuggestions(suggestions);
                }

                // Clear the connector name input for next file
                setConnectorNames((prev) => ({
                  ...prev,
                  ["PDF"]: "",
                }));

                // Clear any validation errors
                setConnectorNameErrors((prev) => ({
                  ...prev,
                  ["PDF"]: null,
                }));

                // Hide the add form after successful upload
                setShowAddForm(false);
              }
              // If extraction failed, error was already shown by uploadFileName
            }
            
          } catch (error) {
            console.error(`Error processing ${fileType} file:`, error);
            setMyLoading(false);
            Swal.fire({
              icon: "error",
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
              title: "Upload Failed",
              text: `Failed to process ${fileType} file. Please try again.`,
            });
          }
        } else {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Invalid File Format</h4>
                   <p style="font-size: 16px;">The uploaded file "<strong>${file.name.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")}</strong>" does not match the configured connector type. ${normalizedType === "PDF" ? "Please upload a PDF file (.pdf)." : "Please upload an Excel file (.xlsx or .xls)."}</p>`,
          });
        }
      }
    },
    [connectorNames]
  );

  const processExcel = async (newdata) => {
    try {
      const requestOptions = newdata;
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}upload-file`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestOptions),
      });
      const data = await response.json();
      setMyLoading(false);
      setApiDone(true);
      setResult(data);
      setHeaderFields(data);
      setActiveStep(2);
    } catch (error) {}
  };

  const uploadExcel = async (newdata) => {
    try {
      const requestOptions = newdata;
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}file`, {
        method: "POST",
        body: requestOptions,
      });
      const data = await response.json();
      setMyLoading(false);
      setApiDone(true);
      setResult(data);
      setHeaderFields(data);
      setActiveStep(2);
    } catch (error) {}
  };

  const excelH = async (e, i) => {
    document.getElementById("excel" + i).value = e;
    const updatedSelections = [...selectedOptions];
    updatedSelections[i] = e;
    setSelectedOptions(updatedSelections);
  };

  const connector = async (e, i) => {
    document.getElementById("connector" + i).value = e;
  };

  useEffect(() => {
    // If there are selected Excel files, but no selected div, select the first Excel file
    if (selectedExcel.length > 0 && selectedDiv === null) {
      setSelectedDiv(selectedExcel[0]);
    }
  }, [selectedExcel, selectedDiv]);

  const handleDivClick = (divName) => {
    console.log(divName);
    if (selectedExcel.includes(divName)) {
      setSelectedDiv(divName);
    } else {
      setSelectedDiv(null);
    }
  };

  /* For the connectors multiple selection */
  const handleClick = (item) => {
    const updatedSelection = [...selectedExcel];

    // Toggle the selection
    if (updatedSelection.includes(item)) {
      updatedSelection.splice(updatedSelection.indexOf(item), 1);
    } else {
      updatedSelection.push(item);
    }

    localStorage.setItem("type", JSON.stringify(updatedSelection));
    setSelectedExcel(updatedSelection);
  };

  useEffect(() => {
    if (!selectedExcel || selectedExcel.length === 0) {
      setSelectedConnectors(""); // Reset when empty
    } else {
      const selectedConnectors = selectedExcel
        .map((item) => String(item).replace(/\s+/g, "")) // Convert to string & remove spaces
        .join(", ");

      setSelectedConnectors(selectedConnectors);
    }
  }, [selectedExcel]);

  const [showDefaultModal, setShowDefaultModal] = useState(false);

  const handleOpenDefaultModal = (rowData, rowIndex) => {
    setCurrentDefaultRow(rowData);
    setCurrentDefaultRowIndex(rowIndex);
    setDefaultValue(defaultValues[rowIndex] || "");
    setShowDefaultModal(true);
  };
  const handleCloseDefaultModal = () => {
    setShowDefaultModal(false);
    setDefaultValue("");
    setCurrentDefaultRow(null);
    setCurrentDefaultRowIndex(null);
  };
  const handleSaveDefaultValue = () => {
    if (currentDefaultRowIndex !== null && defaultValue.trim()) {
      // Save the default value
      setDefaultValues((prev) => ({
        ...prev,
        [currentDefaultRowIndex]: defaultValue.trim(),
      }));

      // Update the selected options to show default value
      const updatedOptions = [...selectedOptions];
      updatedOptions[currentDefaultRowIndex] = `Default: ${defaultValue.trim()}`;
      setSelectedOptions(updatedOptions);

      // Update hidden input
      if (document.getElementById(`excel${currentDefaultRowIndex}`)) {
        document.getElementById(`excel${currentDefaultRowIndex}`).value = `Default: ${defaultValue.trim()}`;
      }

      toast.success("Default value saved successfully!");
    }
    setShowDefaultModal(false);
    setDefaultValue("");
    setCurrentDefaultRow(null);
    setCurrentDefaultRowIndex(null);
  };

  const containerRef = useRef();
  const getCurrentISODate = () => {
    const now = new Date();
    return now.toISOString(); // Returns the current date and time in ISO 8601 format
  };

  let handleSubmit = async (e) => {
    setMyLoading(true);
    e.preventDefault();

    // Validate that Data Frequency is selected
    if (!dataFrequency) {
      setMyLoading(false);
      Swal.fire({
        icon: "error",
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        title: "Data Frequency Required",
        text: "Please select a data frequency before saving the configuration.",
      });
      return;
    }
    // Merging the arrays - Build field mapping from selectedOptions and selectedConnectors
    const mergedArray = [];

    // Build field mapping from the selected options and connectors
    for (let i = 0; i < excelfields.length; i++) {
      const field = excelfields[i];
      const selectedValue = selectedOptions[i];
      const selectedConnector = selectedConnectors[i];

      if (selectedValue && selectedValue !== "" && selectedConnector && selectedConnector !== "") {
        mergedArray.push({
          leftHeader: selectedValue, // Field from data source
          rightHeader: field.key, // Data requirement field
          centerHeader: selectedConnector, // Connector type
        });
      }
    }

    // Function to filter the mergedArray and build the fieldMapping based on connector type
    const buildConnectorsData = (selectedExcel) => {
      const connectorsData = [];

      selectedExcel.forEach((item) => {
        if (item === "Excel") {
          // For Excel, create multiple connectors for each uploaded file
          excelFiles.forEach((excelFile, index) => {
            // Filter mergedArray for this specific Excel connector
            // If there's only one Excel file, it might be mapped as "Excel" instead of connector name
            const connectorKey = excelFiles.length === 1 ? "Excel" : excelFile.connectorName;
            const fieldMapping = mergedArray
              .filter((mapItem) => mapItem.centerHeader === connectorKey) // Filter by connector key
              .reduce((acc, mapItem) => {
                acc[mapItem.rightHeader] = mapItem.leftHeader; // Map data requirement to field from data source
                return acc;
              }, {});

            // Build default mappings from defaultValues state
            const defaultMappings = Object.keys(defaultValues).reduce((acc, rowIndex) => {
              const fieldKey = excelfields[rowIndex]?.key;
              if (fieldKey && defaultValues[rowIndex]) {
                acc[fieldKey] = defaultValues[rowIndex];
              }
              return acc;
            }, {});

            connectorsData.push({
              type: "Excel",
              connectorName: excelFile.connectorName,
              fileName: excelFile.fileName,
              blobFileName: excelFile.blobFileName,
              blobUrl: excelFile.blobUrl,
              identifier: "xyz",
              fieldMapping,
              defaultMappings,
              clientId: "Ecoprism",
              subClientId: "Ecoprism123",
              connectionHash: "2a8bea04931fc50c68083c337a796da38cb371183a91b2f3803ae1011a98",
              connectionFeedTopic: "abcd",
              connectionFeedTopicSecretKv: "83c337a796da38cb371183a91b2f",
            });
          });
        } else if (item === "PDF") {
          // For PDF, create multiple connectors for each uploaded file
          pdfFiles.forEach((pdfFile, index) => {
            const fieldMapping = mergedArray
              .filter((mapItem) => mapItem.centerHeader === item)
              .reduce((acc, mapItem) => {
                acc[mapItem.rightHeader] = mapItem.leftHeader;
                return acc;
              }, {});

            // Build default mappings from defaultValues state
            const defaultMappings = Object.keys(defaultValues).reduce((acc, rowIndex) => {
              const fieldKey = excelfields[rowIndex]?.key;
              if (fieldKey && defaultValues[rowIndex]) {
                acc[fieldKey] = defaultValues[rowIndex];
              }
              return acc;
            }, {});

            connectorsData.push({
              type: "PDF",
              connectorName: pdfFile.connectorName,
              fileName: pdfFile.fileName,
              blobFileName: pdfFile.blobFileName,
              blobUrl: pdfFile.blobUrl,
              identifier: "xyz",
              fieldMapping,
              defaultMappings,
              sourceLabels: pdfSourceLabels,
              clientId: "Ecoprism",
              subClientId: "Ecoprism123",
              connectionHash: "2a8bea04931fc50c68083c337a796da38cb371183a91b2f3803ae1011a98",
              connectionFeedTopic: "abcd",
              connectionFeedTopicSecretKv: "83c337a796da38cb371183a91b2f",
            });
          });
        } else {
          // For other connector types (non-Excel, non-PDF), use the original logic
          const fieldMapping = mergedArray
            .filter((mapItem) => mapItem.centerHeader === item) // Filter by type (Azure Table Storage, API, etc.)
            .reduce((acc, mapItem) => {
              acc[mapItem.rightHeader] = mapItem.leftHeader; // Map data requirement to field from data source
              return acc;
            }, {});

          // Build default mappings from defaultValues state
          const defaultMappings = Object.keys(defaultValues).reduce((acc, rowIndex) => {
            const fieldKey = excelfields[rowIndex]?.key;
            if (fieldKey && defaultValues[rowIndex]) {
              acc[fieldKey] = defaultValues[rowIndex];
            }
            return acc;
          }, {});

          // Return the structure based on type
          if (item === "Azure Table Storage") {
            connectorsData.push({
              type: item,
              identifier: "xyz",
              authMethod: "OAuth",
              authDetails: {
                type: "OAuth",
                AccessTokenUrl: accesstokenurl,
                ClientId: clientid,
                ClientSecret: clientsecret,
                Scope: scope,
                TenantId: tenantid,
              },
              storageAccountName: accountname,
              ResourceUrl: resource,
              tableName: tablename,
              query: query,
              fieldMapping, // Add the fieldMapping here as well
              defaultMappings,
              HttpMethod: "POST",
            });
          } else if (item === "API") {
            connectorsData.push({
              type: item,
              identifier: "xyz",
              authMethod: "API",
              authDetails: {
                Key: apikey,
                Value: apivalue,
              },
              ResourceUrl: resource,
              query: query,
              clientid: apiclientid,
              subclientid: apisubclientid,
              fieldMapping, // Add the fieldMapping here as well
              defaultMappings,
              HttpMethod: "POST",
            });
          }
        }
      });

      return connectorsData;
    };

    // Call the function to build connectors data
    const connectorsData = buildConnectorsData(selectedExcel);

    // Debug logging
    console.log("Field Mapping Debug:");
    console.log("selectedOptions:", selectedOptions);
    console.log("selectedConnectors:", selectedConnectors);
    console.log("mergedArray:", mergedArray);
    console.log("connectorsData:", connectorsData);

    const formattedString = selectedExcel.map((item) => item.replace(/\s+/g, "")).join("");

    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}SaveCompositeConnectorConfig`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({
          siteLocationId: sitelocation1,
          legalEntity: legalEntity,
          companyId: companyid,
          name: formattedString,
          module: "abcde",
          esg: esg,
          esgMetric: esgParameter,
          connectors: connectorsData,
          topic: topic,
          subTopic: subTopic,
          schedule: {
            frequency: dataFrequency,
            timeOfDay: "14:00",
            daysOfWeek: ["Monday", "Wednesday", "Friday"],
            dayOfMonth: 15,
            specificDateTime: getCurrentISODate(),
          },
          createdAt: getCurrentISODate(),
          updatedAt: getCurrentISODate(),
          isActive: true,
        }),
      });
      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson.success == false) {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: responseJson.data,
          });
        } else if (responseJson.status == 400) {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: responseJson.title,
          });
        } else {
          setMyLoading(false);
          // Show success popup, then redirect
          Swal.fire({
            icon: "success",
            html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connection Created successfully</p>',
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
            confirmButtonText: "OK",
          }).then(() => {
            navigate("/newallconfig");
          });
        }
      }
    } catch (err) {
      setMyLoading(false);
      console.log(err);
    }
  };
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const handleCancel = () => {
    setActiveStep(0); // Reset the active step to 0
  };

  const [connectionType, setConnectionType] = useState("");
  const connectionTypeOptions = [
    { label: "OAuth", value: "OAuth" },
    { label: "API Key", value: "APIkey" },
  ];

  const handleConnectionTypeChange = (e) => {
    setConnectionType(e.target.value);
  };

  const checkApiConnection = async (type) => {
    setMyLoading(true);

    try {
      let res;
      if (type === "APIKey") {
        console.log(type);
        console.log(formData);
        if (formData.key === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter API Key",
          });
        }
        if (formData.value === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter Value Here",
          });
        }
        if (formData.resourceUrl === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter Resource Url",
          });
        }
        res = await fetch(`${process.env.REACT_APP_BASE_API_URL}checkApiConnection`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
            key: formData.key,
            value: formData.value,
            resource: formData.resourceUrl,
          },
          body: JSON.stringify({
            ConnectorName: "API",
            authMethod: "APIKey",
            authDetails: {
              Key: formData.key,
              Value: formData.value,
            },
            ResourceUrl: formData.resourceUrl,
          }),
        });
      } else {
        if (formData.clientid === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter client id",
          });
        }
        if (formData.clientsecret === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter client secret",
          });
        }
        if (formData.scope === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter scope",
          });
        }
        if (formData.accesstokenurl === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter access token url",
          });
        }
        if (formData.tenantid === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter tenant id",
          });
        }
        if (formData.resource === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter resource urls",
          });
        }
        res = await fetch(`${process.env.REACT_APP_BASE_API_URL}checkApiConnection`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
          },
          body: JSON.stringify({
            ConnectorName: "API",
            authMethod: "OAuth",
            authDetails: {
              type: "OAuth",
              AccessTokenUrl: formData.accesstokenurl,
              ClientId: formData.clientid,
              ClientSecret: formData.clientsecret,
              Scope: formData.scope,
              TenantId: formData.tenantid,
            },
            storageAccountName: formData.accountname,
            ResourceUrl: formData.resourceUrl,
            tableName: formData.tablename,
            query: formData.query,
          }),
        });
      }

      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson === true) {
          let res1;
          if (type === "APIkey") {
            res1 = await fetch(`${process.env.REACT_APP_BASE_API_URL}getapifields`, {
              method: "POST",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                username: username,
                key: formData.key,
                value: formData.value,
                resource: formData.resourceUrl,
              },
              body: JSON.stringify({
                ConnectorName: "API",
                authMethod: "APIKey",
                authDetails: {
                  Key: formData.key,
                  Value: formData.value,
                },
                ResourceUrl: formData.resourceUrl,
              }),
            });
          } else {
            res1 = await fetch(`${process.env.REACT_APP_BASE_API_URL}getapifields`, {
              method: "POST",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                username: username,
                key: formData.key,
                value: formData.value,
                resource: formData.resourceUrl,
              },
              body: JSON.stringify({
                ConnectorName: "API",
                authMethod: "OAuth",
                authDetails: {
                  type: "OAuth",
                  AccessTokenUrl: formData.accesstokenurl,
                  ClientId: formData.clientid,
                  ClientSecret: formData.clientsecret,
                  Scope: formData.scope,
                  TenantId: formData.tenantid,
                },
                storageAccountName: formData.accountname,
                ResourceUrl: formData.resourceUrl,
                tableName: formData.tablename,
                query: formData.query,
              }),
            });
          }
          if (res1.status === 200) {
            const responseJson1 = await res1.json();
            if (responseJson1.success == false) {
              setMyLoading(false);
              Swal.fire({
                icon: "error",
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                title: "Oops...",
                text: responseJson.data,
              });
            } else if (responseJson1.status == 400) {
              setMyLoading(false);
              Swal.fire({
                icon: "error",
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                title: "Oops...",
                text: responseJson.title,
              });
            } else {
              setMyLoading(false);
              Swal.fire({
                icon: "success",
                html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connection Created successfully</p>',
                iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
              });
              if (type === "APIkey") {
                setAPIFields(responseJson1);
              }
              if (type === "OAuth") {
                setAPIFields(responseJson1);
              }
            }
          }
        } else {
          setMyLoading(false);
          setAzureAPIMessage("");
        }
      } else {
        setMyLoading(false);
      }
    } catch (err) {
      setMyLoading(false);
    }
  };

  const checkAzureConnection = async (selectedExcel) => {
    setMyLoading(true);
    try {
      let res;
      if (selectedExcel === "APIKey") {
        if (apikey === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter API Key",
          });
        }
        if (apivalue === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter Value Here",
          });
        }
        if (resource === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter Resource Url",
          });
        }
        res = await fetch(`${process.env.REACT_APP_BASE_API_URL}checkApiConnection`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
            key: apikey,
            value: apivalue,
            resource: resource,
          },
          body: JSON.stringify({
            ConnectorName: "Azure Table Storage",
            authMethod: "APIKey",
            authDetails: {
              Key: apikey,
              Value: apivalue,
            },
            ResourceUrl: resource,
          }),
        });
      } else {
        if (clientid === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter client id",
          });
        }
        if (clientsecret === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter client secret",
          });
        }
        if (scope === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter scope",
          });
        }
        if (accesstokenurl === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter access token url",
          });
        }
        if (tenantid === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter tenant id",
          });
        }
        if (resource === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter resource urls",
          });
        }
        res = await fetch(`${process.env.REACT_APP_BASE_API_URL}checkApiConnection`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
          },
          body: JSON.stringify({
            ConnectorName: "Azure Table Storage",
            authMethod: "OAuth",
            authDetails: {
              type: "OAuth",
              AccessTokenUrl: accesstokenurl,
              ClientId: clientid,
              ClientSecret: clientsecret,
              Scope: scope,
              TenantId: tenantid,
            },
            storageAccountName: accountname,
            ResourceUrl: resource,
            tableName: tablename,
            query: query,
          }),
        });
      }

      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson === true) {
          let res1;
          if (connectionType === "APIkey") {
            res1 = await fetch(`${process.env.REACT_APP_BASE_API_URL}getapifields`, {
              method: "POST",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                username: username,
                key: apikey,
                value: apivalue,
                resource: resource,
              },
              body: JSON.stringify({
                ConnectorName: "Azure Table Storage",
                authMethod: "APIKey",
                authDetails: {
                  Key: apikey,
                  Value: apivalue,
                },
                ResourceUrl: resource,
              }),
            });
          } else {
            res1 = await fetch(`${process.env.REACT_APP_BASE_API_URL}getapifields`, {
              method: "POST",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                username: username,
                key: apikey,
                value: apivalue,
                resource: resource,
              },
              body: JSON.stringify({
                ConnectorName: "Azure Table Storage",
                authMethod: "OAuth",
                authDetails: {
                  type: "OAuth",
                  AccessTokenUrl: accesstokenurl,
                  ClientId: clientid,
                  ClientSecret: clientsecret,
                  Scope: scope,
                  TenantId: tenantid,
                },
                storageAccountName: accountname,
                ResourceUrl: resource,
                tableName: tablename,
                query: query,
              }),
            });
          }
          if (res1.status === 200) {
            const responseJson1 = await res1.json();
            if (responseJson1.success == false) {
              setMyLoading(false);
              Swal.fire({
                icon: "error",
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                title: "Oops...",
                text: responseJson.data,
              });
            } else if (responseJson1.status == 400) {
              setMyLoading(false);
              Swal.fire({
                icon: "error",
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                title: "Oops...",
                text: responseJson.title,
              });
            } else {
              setMyLoading(false);
              Swal.fire({
                icon: "success",
                html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connection Created successfully</p>',
                iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
              });
              if (selectedExcel === "Azure Table Storage") {
                setAzureAPIMessage("Azure Table Storage");
                setAzureTableStorageFields(responseJson1);
              }
            }
          }
        } else {
          setMyLoading(false);
          setAzureAPIMessage("");
        }
      } else {
        setMyLoading(false);
      }
    } catch (err) {
      setMyLoading(false);
    }
  };

  const connectorData = [
    { type: "Excel", name: "Abc excel", fieldCount: 8 },
    { type: "API", name: "Xyz API", fieldCount: 10 },
  ];

  const onChangeESG = (e) => {
    fetchESGParameter(e);
  };
  const onChangeESGParameter = (e) => {
    fetchTopic(e);
  };
  const onChangeTopic = (e) => {
    fetchSubTopic(e);
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  return (
    <React.Fragment>
      <div id="wrapper">
        <div>
          {myloading && (
            <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <CircularProgress color="inherit" />
                <Typography variant="h6" color="inherit">Processing file...</Typography>
              </Box>
            </Backdrop>
          )}
        </div>
        <div>
          <Toaster position="top-right" reverseOrder={false} />
        </div>
        {renderHeader()}
        <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
          <div className="container formpd configuration-wizard">
            <div className="steps__containt-body">
            {loading && <div class="loading">Loading&#8230;</div>}
            <div className="steps__containt-left">
              <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel
                      icon={
                        <Badge
                          className="badgeRoot badgeContent"
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          badgeContent={
                            <>
                              <img src={step.active <= count ? "./assets/img/Assets/configration_icon/White/Outer Circle.png" : iconDotInactive} alt="Outer Circle" className="outerCircle" />
                              <img src={step.active <= count ? "./assets/img/Assets/configration_icon/White/Inner circle.png" : iconBackgroundInactive} alt="Inner Circle" className={`${step.active <= count ? "innerCircle" : "innerCircleInactive"}`} />
                              <img src={customIcons[index]} alt={step.active <= count ? "Custom Icon" : "Inactive Icon"} className="customIcon" />
                            </>
                          }
                        >
                          <Avatar alt={`Step ${index + 1}`} className={`'avatar' ${step.active ? "activeIcon" : "inactiveIcon"}`} />
                        </Badge>
                      }
                    >
                      {step.label}
                    </StepLabel>
                    <StepContent>
                      <Typography>{step.description}</Typography>
                      <Box sx={{ mb: 2 }}>
                        <div></div>
                      </Box>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
            </div>
            <div className="revized__containt-right">
              {/* Step 1 */}
              {activeStep === 0 && (
                <div>
                  <div className="steps__containt-hader ml-4">
                    <h3 className="title">Select ESG Parameter</h3>
                    <p>Select the data reporting unit to set up the new connection.</p>
                  </div>
                  <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0" }} />
                  <div className="revized__container">
                    <form>
                      <div className="row">
                        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                          <div className="mb-3">
                            <label className="formlable">
                              ESG Selection <span className="mark-form">*</span>
                            </label>
                            <Dropdown
                              value={esg}
                              options={esgOptions}
                              onChange={(e) => {
                                setESG(e.value);
                                setMatrics(e.value);
                                fetchESGParameter(e.value); // loads ESG parameters via API
                                checkAppName2(e.value); // your existing helper
                              }}
                              placeholder="Select ESG"
                              className="p-inputtext-sm wd-100"
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="formlable">
                              ESG Parameter <span className="mark-form">*</span>
                            </label>
                            <Dropdown
                              value={esgParameter}
                              options={esgParamOptions}
                              onChange={(e) => {
                                setESGParameter(e.value);
                                fetchTopic(e.value); // loads Topics via API
                              }}
                              placeholder="Select ESG Parameter"
                              className="p-inputtext-sm wd-100"
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="formlable">
                              Topic<span className="mark-form">*</span>
                            </label>
                            <Dropdown
                              value={topic}
                              options={topicOptions}
                              onChange={(e) => {
                                setTopic(e.value);
                                setMatrics(e.value);
                                fetchSubTopic(e.value); // loads Subtopics via API
                              }}
                              placeholder="Select topic"
                              className="p-inputtext-sm wd-100"
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="formlable">
                              Sub Topic<span className="mark-form"></span>
                            </label>
                            <Dropdown value={subTopic} options={subTopicOptions} onChange={(e) => setSubTopic(e.value)} placeholder="Select subtopic" className="p-inputtext-sm wd-100" required />
                          </div>
                          <div className="form-group mb-4">
                            <label className="formlable">
                              Reporting Unit<span className="mark-form">*</span>
                            </label>

                            <div className="d-flex gap-4 mb-3">
                              <div className="d-flex align-items-center gap-2">
                                <RadioButton inputId="siteOption" name="parameterOption" value="site" onChange={(e) => setParameterOption(e.value)} checked={parameterOption === "site"} />
                                <label htmlFor="siteOption" style={{ fontSize: "14px", marginBottom: "0" }}>
                                  Site Location
                                </label>
                              </div>

                              <div className="d-flex align-items-center gap-2">
                                <RadioButton inputId="legalOption" name="parameterOption" value="legal" onChange={(e) => setParameterOption(e.value)} checked={parameterOption === "legal"} />
                                <label htmlFor="legalOption" style={{ fontSize: "14px", marginBottom: "0" }}>
                                  Legal Entity
                                </label>
                              </div>
                            </div>

                            {parameterOption === "site" && (
                              <div className="mb-3">
                                <label className="formlable">
                                  Site Location<span className="mark-form">*</span>
                                </label>
                                <Dropdown
                                  value={sitelocation1}
                                  options={siteLocationOptions}
                                  onChange={(e) => {
                                    setSiteLocation1(e.value);
                                    checkAppName1(e.value);
                                  }}
                                  placeholder="Select site location"
                                  className="p-inputtext-sm wd-100"
                                  filter
                                  filterPlaceholder="Search site location"
                                  showClear
                                  required
                                />
                              </div>
                            )}

                            {parameterOption === "legal" && (
                              <div className="mt-3">
                                <label className="formlable">
                                  Legal Entity<span className="mark-form">*</span>
                                </label>
                                <Dropdown
                                  value={legalEntity}
                                  options={legalEntityOptions}
                                  onChange={(e) => {
                                    setLegalEntity(e.value);
                                    checkAppName1(e.value);
                                  }}
                                  placeholder="Select legal entity"
                                  className="p-inputtext-sm wd-100"
                                  filter
                                  filterPlaceholder="Search legal entity"
                                  showClear
                                  required
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="next__previous-buttons mt-0">
                      <div className="d-flex">
                        <Button
                          className="next-button"
                          onClick={handleNext}
                          variant="contained"
                          size="medium"
                          sx={{
                            color: "#fff",
                            backgroundColor: "#407775",
                            width: "120px",
                            height: "41px",
                            borderRadius: "10px",
                            textAlign: "center",
                          }}
                          disabled={!esg || !esgParameter || !topic || (parameterOption === "site" ? !sitelocation1 : parameterOption === "legal" ? !legalEntity : true)}
                        >
                          Next
                          <p style={{ paddingTop: "17px" }}>&gt;</p>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 2 */}
              {activeStep === 1 && (
                <div>
                  <div className="steps__containt-hader ml-4">
                    <h3 className="title">Choose data connector</h3>
                    <p>Simplify data collection using import options such as excel sheets, XML files and API integration.</p>
                  </div>
                  <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0" }} />
                  <div className="revized__container">
                    <div>
                      <label className="form-label">
                        Choose connector <span className="mark-form">*</span>
                      </label>
                      <ul className="list dropzone__list">
                        {getappnames && getappnames.configuredAppNames.length === 0 ? (
                          <div></div>
                        ) : (
                          <div style={cardStyles.heading} className="text-conn">
                            Used connector
                          </div>
                        )}

                        {getappnames &&
                          getappnames.configuredAppNames.map((appname) => {
                            if (appname === "Excel") {
                              return (
                                // <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname}>
                                //   <label className="custom-checkbox" onClick={() => handleClick(appname)}>
                                //     <input
                                //       type="checkbox"
                                //       checked={selectedExcel.includes(appname)}
                                //       onChange={() => handleClick(appname)} // also handle change event
                                //     />
                                //     <span className="checkmark"></span>
                                //   </label>
                                //   <img src="assets/img/excel.png" onClick={() => handleClick(appname)} />
                                //   <h6 onClick={() => handleClick(appname)}>{appname}</h6>
                                // </li>
                                <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} onClick={() => handleClick(appname)}>
                                  <label className="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span className="checkmark"></span>
                                  </label>
                                  <img src="assets/img/excel.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "PDF") {
                              return (
                                <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} onClick={() => handleClick(appname)}>
                                  <label className="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span className="checkmark"></span>
                                  </label>
                                  <img src="assets/img/pdf.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "Dynamics") {
                              return (
                                <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} onClick={() => handleClick(appname)}>
                                  <label className="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span className="checkmark"></span>
                                  </label>
                                  <img src="assets/img/dynamics.png" onClick={() => handleClick(appname)} />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                          })}

                        {getappnames && getappnames.availableToConfigureAppNames.length === 0 ? (
                          <div></div>
                        ) : (
                          <div style={cardStyles.heading} className="text-conn">
                            Available connector
                          </div>
                        )}

                        {getappnames &&
                          getappnames.availableToConfigureAppNames.map((appname) => {
                            if (appname === "Excel") {
                              return (
                                <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} htmlFor={appname} onClick={() => handleClick(appname)}>
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  <img src="assets/img/excel.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "PDF") {
                              return (
                                <li className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} onClick={() => handleClick(appname)}>
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  <img src="assets/img/pdf.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "Dynamics") {
                              return (
                                <li className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} onClick={() => handleClick(appname)}>
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  <img src="assets/img/dynamics.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                          })}
                        {/* Cascading Connectors */}
                        {getappnames &&
                          getappnames.cascadesConnectors.map((appname) => {
                            if (appname.name === "Azure Table Storage") {
                              return (
                                <li className={selectedExcel.includes(appname.name) ? "active items" : "items"} value={appname.name} onClick={() => handleClick(appname.name)}>
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname.name)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  <img src="assets/img/azuretablestorage.png" />
                                  <h6>{appname.name}</h6>
                                </li>
                              );
                            }
                            if (appname.name === "API") {
                              return (
                                <li
                                  className={selectedExcel.includes(appname.name) ? "active items" : "items"}
                                  value={appname.name}
                                  onClick={() => {
                                    handleClick(appname.name);
                                  }}
                                >
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname.name)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  {/*<input
                                      type="checkbox"
                                      className="checkbox"
                                      checked={selectedExcel.includes(appname.name)}/>*/}
                                  <img src="assets/img/api.png" />
                                  <h6>{appname.name}</h6>
                                </li>
                              );
                            }
                          })}

                        {getappnames && getappnames.comingSoonAppNames.length === 0 ? (
                          <div></div>
                        ) : (
                          <div style={cardStyles.heading} className="text-conn">
                            Coming soon connector
                          </div>
                        )}

                        {getappnames &&
                          getappnames.comingSoonAppNames.map((appname) => {
                            if (appname === "Meter") {
                              return (
                                <li className="items">
                                  <img src="assets/img/meterno.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "SAP") {
                              return (
                                <li className="items">
                                  <img src="assets/img/sap.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "Oracle") {
                              return (
                                <li className="items">
                                  <img src="assets/img/oracle.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "Dynamics") {
                              return (
                                <li className="items">
                                  <img src="assets/img/dynamics.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "SalesForce") {
                              return (
                                <li className="items">
                                  <img src="assets/img/salesforce.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                          })}
                      </ul>
                    </div>
                    <div className="next__previous-buttons">
                      <div className="d-flex gap-3">
                        <Button className="outline-btn" variant="outlined" onClick={handleBack}>
                          <p style={{ paddingTop: "17px", color: "#407775" }}>&lt;</p>
                          Back
                        </Button>
                        <Button variant="contained" color="primary" className="next-button" onClick={handleNext} disabled={!selectedExcel}>
                          Next <p style={{ paddingTop: "17px" }}>&gt;</p>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 3 */}
              {activeStep === 2 && (
                <div>
                  <div className="steps__containt-hader ml-4">
                    <h3 className="title">Create connection</h3>
                    <p>Simply data collection using import options such as excel sheets, XML files and API integration.</p>
                  </div>
                  <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0", marginBottom: "0" }} />
                  <div className="revized__side__container">
                    <div className="child-div-10">
                      {selectedExcel.map((excelType, index) => (
                        <div key={index} className={`clickable-div ${selectedDiv === excelType ? "selected" : ""}`} onClick={() => handleDivClick(excelType)}>
                          <img src={`assets/img/${excelType.toLowerCase().replace(/\s+/g, "")}.png`} alt={excelType} />
                          <label>{excelType}</label>
                        </div>
                      ))}
                    </div>
                    <div className="child-div-90">
                      {selectedExcel.map((excelType, index) =>
                        selectedDiv === excelType ? (
                          <div key={index} className="connector-content">
                            {excelType === "Excel" && (
                              <div>
                                {/* Show uploaded files table if any files exist */}
                                {excelFiles && excelFiles.length > 0 && (
                                  <div style={{ marginBottom: "20px" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                                      <div
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          borderRadius: "50%",
                                          backgroundColor: "#28a745",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <span style={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>✓</span>
                                      </div>
                                      <span style={{ color: "#28a745", fontWeight: "500" }}>File successfully added.</span>
                                    </div>

                                    <div
                                      style={{
                                        border: "1px solid #E0E0E0",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        backgroundColor: "#fff",
                                      }}
                                    >
                                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                          <tr style={{ backgroundColor: "#F8F9FA" }}>
                                            <th
                                              style={{
                                                padding: "12px 16px",
                                                textAlign: "left",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "#495057",
                                                borderBottom: "1px solid #E0E0E0",
                                              }}
                                            >
                                              Connector name
                                            </th>
                                            <th
                                              style={{
                                                padding: "12px 16px",
                                                textAlign: "left",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "#495057",
                                                borderBottom: "1px solid #E0E0E0",
                                              }}
                                            >
                                              File Name
                                            </th>
                                            <th
                                              style={{
                                                padding: "12px 16px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "#495057",
                                                borderBottom: "1px solid #E0E0E0",
                                                width: "100px",
                                              }}
                                            >
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {excelFiles.map((file, fileIndex) => (
                                            <tr key={fileIndex}>
                                              <td
                                                style={{
                                                  padding: "12px 16px",
                                                  borderBottom: fileIndex === excelFiles.length - 1 ? "none" : "1px solid #E0E0E0",
                                                  fontSize: "14px",
                                                  color: "#495057",
                                                }}
                                              >
                                                {file.connectorName || `Excel Connector ${fileIndex + 1}`}
                                              </td>
                                              <td
                                                style={{
                                                  padding: "12px 16px",
                                                  borderBottom: fileIndex === excelFiles.length - 1 ? "none" : "1px solid #E0E0E0",
                                                  fontSize: "14px",
                                                  color: "#6c757d",
                                                }}
                                              >
                                                {file.fileName}
                                              </td>
                                              <td
                                                style={{
                                                  padding: "12px 16px",
                                                  borderBottom: fileIndex === excelFiles.length - 1 ? "none" : "1px solid #E0E0E0",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <Button
                                                  variant="outlined"
                                                  size="small"
                                                  style={{
                                                    color: "#dc3545",
                                                    borderColor: "#dc3545",
                                                    fontSize: "12px",
                                                    padding: "4px 12px",
                                                    minWidth: "auto",
                                                  }}
                                                  onClick={() => {
                                                    const fileToRemove = excelFiles[fileIndex];
                                                    const updatedFiles = excelFiles.filter((_, index) => index !== fileIndex);
                                                    setExcelFiles(updatedFiles);

                                                    // Remove headers for this connector from individualExcelHeaders
                                                    setIndividualExcelHeaders((prev) => {
                                                      const updated = { ...prev };
                                                      delete updated[fileToRemove.connectorName];
                                                      return updated;
                                                    });

                                                    if (updatedFiles.length === 0) {
                                                      setImportFile("");
                                                    }
                                                  }}
                                                >
                                                  Remove
                                                </Button>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>

                                    <div style={{ textAlign: "right", marginTop: "15px" }}>
                                      <Button
                                        variant="outlined"
                                        style={{
                                          color: "#407775",
                                          borderColor: "#407775",
                                          fontSize: "14px",
                                          padding: "8px 16px",
                                        }}
                                        onClick={() => {
                                          setShowAddForm(true);
                                        }}
                                      >
                                        + Add another Excel
                                      </Button>
                                    </div>
                                  </div>
                                )}

                                {/* Always show add form when showAddForm is true or no files exist */}
                                {(showAddForm || excelFiles.length === 0) && (
                                  <div className="add-excel-section">
                                    <label className="formlable" htmlFor="formGroupExampleInput">
                                      Connector Name <span className="mark-form">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      value={connectorNames["Excel"] || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setConnectorNames((prev) => ({
                                          ...prev,
                                          ["Excel"]: value,
                                        }));

                                        // Real-time validation
                                        const error = validateConnectorName(value, "Excel");
                                        setConnectorNameErrors((prev) => ({
                                          ...prev,
                                          ["Excel"]: error,
                                        }));
                                      }}
                                      className={`form-control ${connectorNameErrors["Excel"] ? "is-invalid" : ""}`}
                                      required
                                      id="formGroupExampleInput"
                                      placeholder="Enter the connector name for this Excel file"
                                      style={{
                                        marginBottom: connectorNameErrors["Excel"] ? "5px" : "15px",
                                        padding: "12px 16px",
                                        border: `1px solid ${connectorNameErrors["Excel"] ? "#dc3545" : "#ced4da"}`,
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                      }}
                                    />
                                    {connectorNameErrors["Excel"] && (
                                      <div
                                        style={{
                                          color: "#dc3545",
                                          fontSize: "12px",
                                          marginBottom: "15px",
                                          marginTop: "5px",
                                        }}
                                      >
                                        {connectorNameErrors["Excel"]}
                                      </div>
                                    )}

                                    <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles, "Excel")}>
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone__section">
                                          <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <div className="dropzone">
                                              <label htmlFor="files" className="dropzone-container">
                                                <div className="file-icon">
                                                  <img className="icon" src="assets/img/import.png" alt="" />
                                                </div>
                                                <div className="dropzone-title">
                                                  <span className="browse">Browse</span> or drag and drop
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                  </div>
                                )}
                              </div>
                            )}
                            {excelType === "PDF" && (
                              <div>
                                {/* Show uploaded files table if any files exist */}
                                {pdfFiles && pdfFiles.length > 0 && (
                                  <div style={{ marginBottom: "20px" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                                      <div
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          borderRadius: "50%",
                                          backgroundColor: "#407775",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="12"
                                          height="12"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="white"
                                          strokeWidth="3"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        >
                                          <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                      </div>
                                      <p style={{ margin: 0, fontWeight: "600", color: "#407775", fontSize: "16px" }}>Uploaded PDFs</p>
                                    </div>

                                    <div
                                      style={{
                                        border: "1px solid #E0E0E0",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        backgroundColor: "#FFFFFF",
                                      }}
                                    >
                                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                          <tr style={{ backgroundColor: "#F8F9FA" }}>
                                            <th
                                              style={{
                                                padding: "12px 16px",
                                                textAlign: "left",
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                color: "#6c757d",
                                                borderBottom: "1px solid #E0E0E0",
                                              }}
                                            >
                                              Connector Name
                                            </th>
                                            <th
                                              style={{
                                                padding: "12px 16px",
                                                textAlign: "left",
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                color: "#6c757d",
                                                borderBottom: "1px solid #E0E0E0",
                                              }}
                                            >
                                              File Name
                                            </th>
                                            <th
                                              style={{
                                                padding: "12px 16px",
                                                textAlign: "center",
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                color: "#6c757d",
                                                borderBottom: "1px solid #E0E0E0",
                                                width: "100px",
                                              }}
                                            >
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {pdfFiles.map((file, fileIndex) => (
                                            <tr key={fileIndex}>
                                              <td
                                                style={{
                                                  padding: "12px 16px",
                                                  borderBottom: fileIndex === pdfFiles.length - 1 ? "none" : "1px solid #E0E0E0",
                                                  fontSize: "14px",
                                                  color: "#495057",
                                                }}
                                              >
                                                {file.connectorName}
                                              </td>
                                              <td
                                                style={{
                                                  padding: "12px 16px",
                                                  borderBottom: fileIndex === pdfFiles.length - 1 ? "none" : "1px solid #E0E0E0",
                                                  fontSize: "14px",
                                                  color: "#6c757d",
                                                }}
                                              >
                                                {file.fileName}
                                              </td>
                                              <td
                                                style={{
                                                  padding: "12px 16px",
                                                  borderBottom: fileIndex === pdfFiles.length - 1 ? "none" : "1px solid #E0E0E0",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <button
                                                  onClick={() => {
                                                    const updatedFiles = pdfFiles.filter((_, index) => index !== fileIndex);
                                                    setPdfFiles(updatedFiles);
                                                    
                                                    // If no files left, reset the form
                                                    if (updatedFiles.length === 0) {
                                                      setShowAddForm(true);
                                                      setConnectorNames((prev) => ({
                                                        ...prev,
                                                        PDF: "",
                                                      }));
                                                    }
                                                  }}
                                                  style={{
                                                    background: "none",
                                                    border: "1px solid #dc3545",
                                                    color: "#dc3545",
                                                    padding: "6px 12px",
                                                    borderRadius: "5px",
                                                    cursor: "pointer",
                                                    fontSize: "13px",
                                                    fontWeight: "500",
                                                    transition: "all 0.2s",
                                                    minWidth: "auto",
                                                  }}
                                                  onMouseOver={(e) => {
                                                    e.currentTarget.style.backgroundColor = "#dc3545";
                                                    e.currentTarget.style.color = "#fff";
                                                  }}
                                                  onMouseOut={(e) => {
                                                    e.currentTarget.style.backgroundColor = "transparent";
                                                    e.currentTarget.style.color = "#dc3545";
                                                  }}
                                                >
                                                  Remove
                                                </button>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                )}

                                {/* Always show add form when showAddForm is true or no files exist */}
                                {(showAddForm || pdfFiles.length === 0) && (
                                  <div className="add-pdf-section">
                                    <label className="formlable" htmlFor="formGroupExampleInput">
                                      Connector Name <span className="mark-form">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      name={`connectorName-${excelType}`}
                                      value={connectorNames[excelType] || ""}
                                      onChange={(e) => {
                                        const newValue = e.target.value;
                                        setConnectorNames((prev) => ({
                                          ...prev,
                                          [excelType]: newValue,
                                        }));
                                        
                                        // Clear error when user starts typing
                                        if (connectorNameErrors[excelType]) {
                                          setConnectorNameErrors((prev) => ({
                                            ...prev,
                                            [excelType]: "",
                                          }));
                                        }
                                      }}
                                      className="form-control"
                                      required
                                      id="formGroupExampleInput"
                                      placeholder="Enter the required connector name"
                                      style={{
                                        borderColor: connectorNameErrors[excelType] ? "#dc3545" : "",
                                      }}
                                    />
                                    {connectorNameErrors[excelType] && (
                                      <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{connectorNameErrors[excelType]}</div>
                                    )}

                                    <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles, "PDF")}>
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone__section">
                                          <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <div className="dropzone">
                                              <label htmlFor="files" className="dropzone-container">
                                                <div className="file-icon">
                                                  <img className="icon" src="assets/img/import.png" alt="" />
                                                </div>
                                                <div className="dropzone-title">
                                                  <span className="browse">Browse</span> or drag and drop
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                  </div>
                                )}

                                {/* Show success message temporarily after upload */}
                                {importpdffile && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      maxWidth: "770px",
                                      width: "100%",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: "#F5F8F8",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "30px",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      <img
                                        src="assets/img/successicon.png"
                                        alt="Success"
                                        style={{
                                          width: "60px",
                                          height: "60px",
                                          marginBottom: "10px",
                                        }}
                                      />
                                      <label style={{ fontWeight: "600", color: "#407775", fontSize: "16px" }}>Successfully uploaded!</label>
                                      <p className="mb-0" style={{ color: "#707070", fontSize: "14px" }}>
                                        {importpdffile}
                                      </p>
                                      <Button
                                        className="refresh-cta mt-3"
                                        onClick={() => {
                                          setImportPDFFile("");
                                          setShowAddForm(true);
                                          setConnectorNames((prev) => ({
                                            ...prev,
                                            PDF: "",
                                          }));
                                        }}
                                      >
                                        + Add Another PDF
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            {excelType === "API" && (
                              <div>
                                <p style={{ color: "#707070" }}>Connect To Data Source</p>
                                <label class="formlable" for="formGroupExampleInput">
                                  Connector Name <span className="mark-form">*</span>
                                </label>
                                <input
                                  type="text"
                                  name={`connectorName-${excelType}`}
                                  value={connectorNames[excelType] || ""}
                                  onChange={(e) =>
                                    setConnectorNames((prev) => ({
                                      ...prev,
                                      [excelType]: e.target.value,
                                    }))
                                  }
                                  className="form-control"
                                  required
                                  id="formGroupExampleInput"
                                  placeholder="Enter the required connector name"
                                />
                                <div className="form-group col-md-12" style={{ paddingLeft: "0px", paddingRight: "0px", maxWidth: "770px" }}>
                                  <div className="form-group">
                                    <label className="formlable" htmlFor="connectionType">
                                      Connection type <span className="mark-form">*</span>
                                    </label>
                                    <Dropdown
                                      id="connectionType"
                                      value={formData.connectionType}
                                      options={connectionTypeOptions}
                                      onChange={(e) => {
                                        setFormData((prevData) => ({
                                          ...prevData,
                                          connectionType: e.value,
                                        }));
                                        handleConnectionTypeChange(e); // if this is a function you defined
                                      }}
                                      placeholder="Select authorization type"
                                      className="p-inputtext-sm wd-100"
                                      required
                                    />
                                  </div>
                                  {formData.connectionType === "APIkey" && (
                                    <div className="form-group">
                                      <div style={{ color: "#1E4B7A" }}>{formData.apiAPIMessage ? <p>{formData.apiAPIMessage} connection created successfully</p> : null}</div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="key">
                                          Key <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setFormData((prevData) => ({
                                              ...prevData,
                                              key: e.target.value,
                                            }));
                                          }}
                                          className="form-control"
                                          required
                                          id="key"
                                          placeholder="Enter key"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="value">
                                          Value<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setFormData((prevData) => ({
                                              ...prevData,
                                              value: e.target.value,
                                            }));
                                          }}
                                          className="form-control"
                                          required
                                          id="value"
                                          placeholder="Enter value"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="resourceUrl3">
                                          Resource URL <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          required
                                          id="resourceUrl"
                                          onChange={(e) => {
                                            setFormData((prevData) => ({
                                              ...prevData,
                                              resourceUrl: e.target.value,
                                            }));
                                          }}
                                          placeholder="Enter resource URL"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-end mt-3">
                                        <Button className="refresh-cta d-flex align-items-center" type="submit" onClick={() => checkApiConnection("APIKey")}>
                                          <img
                                            src="assets/img/validate.svg"
                                            alt="Success Icon"
                                            style={{
                                              marginRight: "8px",
                                              height: "16px",
                                            }}
                                          />
                                          Validate Connection
                                        </Button>
                                      </div>
                                    </div>
                                  )}

                                  {formData.connectionType === "OAuth" && (
                                    <div className="form-group">
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="query">
                                          Query<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setQuery(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="query"
                                          placeholder="Enter your query"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="accessTokenUrl">
                                          Access Token URL<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setAccessTokenUrl(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="accessTokenUrl"
                                          placeholder="Enter access token URL"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="clientId">
                                          Client Id<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setClientID(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="clientId"
                                          placeholder="Enter client ID"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="clientSecret">
                                          Client Secret <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setClientSecret(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="clientSecret"
                                          placeholder="Enter client secret"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="scope">
                                          Scope <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setScope(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="scope"
                                          placeholder="Enter required scope"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="tenantId">
                                          Tenant Id <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setTenantID(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="tenantId"
                                          placeholder="Enter tenant ID"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="resourceUrl4">
                                          Resource URL <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setResource(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="resourceUrl"
                                          placeholder="Enter resource URL"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-end mt-3">
                                        <Button className="refresh-cta d-flex align-items-center" type="submit" onClick={() => checkApiConnection("OAuth")}>
                                          <img
                                            src="assets/img/validate.svg"
                                            alt="Success Icon"
                                            style={{
                                              marginRight: "8px",
                                              height: "16px",
                                            }}
                                          />
                                          Validate Connection
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                            {excelType === "Azure Table Storage" && (
                              <div>
                                <p style={{ color: "#707070" }}>Connect To Data Source</p>
                                <label class="formlable" for="formGroupExampleInput">
                                  Connector Name <span className="mark-form">*</span>
                                </label>
                                <input
                                  type="text"
                                  name={`connectorName-${excelType}`}
                                  value={connectorNames[excelType] || ""}
                                  onChange={(e) =>
                                    setConnectorNames((prev) => ({
                                      ...prev,
                                      [excelType]: e.target.value,
                                    }))
                                  }
                                  className="form-control"
                                  required
                                  id="formGroupExampleInput"
                                  placeholder="Enter the required connector name"
                                />
                                <div className="form-group col-md-12" style={{ paddingLeft: "0px", paddingRight: "0px", maxWidth: "770px" }}>
                                  <div className="form-group">
                                    <label className="formlable" htmlFor="connectionType">
                                      Connection type <span className="mark-form">*</span>
                                    </label>
                                    <Dropdown
                                      id="connectionType"
                                      value={connectionType}
                                      options={connectionTypeOptions}
                                      onChange={(e) => {
                                        setConnectionType(e.value);
                                        handleConnectionTypeChange(e); // if this is a function you defined
                                      }}
                                      placeholder="Select authorization type"
                                      className="p-inputtext-sm wd-100"
                                      required
                                    />
                                  </div>
                                  {connectionType === "APIkey" && (
                                    <div className="form-group">
                                      <div style={{ color: "#1E4B7A" }}>{azureAPIMessage ? <p>{azureAPIMessage} connection created successfully</p> : null}</div>
                                      {selectedExcel.includes("API") && (
                                        <div>
                                          <div className="form-group"></div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="query">
                                              Query<span className="mark-form"></span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setQuery(e.target.value);
                                              }}
                                              className="form-control"
                                              id="query"
                                              placeholder="Enter your query"
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {selectedExcel.includes("Azure Table Storage") && (
                                        <>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="storageAccountName">
                                              Storage Account Name<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setAccoutName(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="storageAccountName"
                                              placeholder="Enter storage account name"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="tableName">
                                              Table Name<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setTableName(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="tableName"
                                              placeholder="Enter table name"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="query">
                                              Query<span className="mark-form"></span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setQuery(e.target.value);
                                              }}
                                              className="form-control"
                                              id="query"
                                              placeholder="Enter your query"
                                            />
                                          </div>
                                        </>
                                      )}
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="key">
                                          Key <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setApiKey(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="key"
                                          placeholder="Enter key"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="value">
                                          Value<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setApiValue(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="value"
                                          placeholder="Enter value"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="resourceUrl3">
                                          Resource URL <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          required
                                          id="resourceUrl"
                                          onChange={(e) => {
                                            setResource(e.target.value);
                                          }}
                                          placeholder="Enter resource URL"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-end mt-3">
                                        <Button className="refresh-cta d-flex align-items-center" type="submit" onClick={() => checkAzureConnection("API")}>
                                          <img
                                            src="assets/img/validate.svg"
                                            alt="Success Icon"
                                            style={{
                                              marginRight: "8px",
                                              height: "16px",
                                            }}
                                          />
                                          Validate Connection
                                        </Button>
                                      </div>
                                    </div>
                                  )}

                                  {connectionType === "OAuth" && (
                                    <div className="form-group">
                                      {selectedExcel.includes("API") && (
                                        <div className="form-group">
                                          <label className="formlable" htmlFor="query">
                                            Query<span className="mark-form">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            onChange={(e) => {
                                              setQuery(e.target.value);
                                            }}
                                            className="form-control"
                                            required
                                            id="query"
                                            placeholder="Enter your query"
                                          />
                                        </div>
                                      )}
                                      {selectedExcel.includes("Azure Table Storage") && (
                                        <>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="storageAccountName">
                                              Storage Account Name<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setAccoutName(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="storageAccountName"
                                              placeholder="Enter storage account name"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="tableName">
                                              Table Name<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setTableName(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="tableName"
                                              placeholder="Enter table name"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="query">
                                              Query<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setQuery(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="query"
                                              placeholder="Enter your query"
                                            />
                                          </div>
                                        </>
                                      )}

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="accessTokenUrl">
                                          Access Token URL<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setAccessTokenUrl(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="accessTokenUrl"
                                          placeholder="Enter access token URL"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="clientId">
                                          Client Id<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setClientID(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="clientId"
                                          placeholder="Enter client ID"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="clientSecret">
                                          Client Secret <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setClientSecret(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="clientSecret"
                                          placeholder="Enter client secret"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="scope">
                                          Scope <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setScope(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="scope"
                                          placeholder="Enter required scope"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="tenantId">
                                          Tenant Id <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setTenantID(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="tenantId"
                                          placeholder="Enter tenant ID"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="resourceUrl4">
                                          Resource URL <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setResource(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="resourceUrl"
                                          placeholder="Enter resource URL"
                                        />
                                      </div>

                                      {connectionType === "OAuth" && (
                                        <div className="d-flex justify-content-end mt-3">
                                          <Button className="refresh-cta d-flex align-items-center" type="submit" onClick={() => checkAzureConnection("Azure Table Storage")}>
                                            <img
                                              src="assets/img/validate.svg"
                                              alt="Success Icon"
                                              style={{
                                                marginRight: "8px",
                                                height: "16px",
                                              }}
                                            />
                                            Validate Connection
                                          </Button>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : null
                      )}
                      <div className="next__previous-buttons">
                        <div className="d-flex gap-3">
                          <Button className="outline-btn" variant="outlined" onClick={handleBack}>
                            Back
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            className="next-button"
                            onClick={handleNext}
                            disabled={
                              // Disable while uploading
                              myloading ||
                              selectedExcel.length === 0 ||
                              // Check if Excel is selected but no files uploaded
                              (selectedExcel.includes("Excel") && (!excelFiles || excelFiles.length === 0)) ||
                              // Check if Excel files are missing connector names
                              (selectedExcel.includes("Excel") && excelFiles.some((file) => !file.connectorName || file.connectorName.trim() === "")) ||
                              // Check if PDF is selected but no files uploaded
                              (selectedExcel.includes("PDF") && (!pdfFiles || pdfFiles.length === 0)) ||
                              // Check if PDF files are missing connector names
                              (selectedExcel.includes("PDF") && pdfFiles.some((file) => !file.connectorName || file.connectorName.trim() === "")) ||
                              // Check if other connectors are selected but don't have names
                              selectedExcel.filter((c) => c !== "Excel" && c !== "PDF").some((connectorType) => !connectorNames[connectorType] || connectorNames[connectorType].trim() === "")
                            }
                          >
                            Next
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 4 */}
              {activeStep === 3 && (
                <div className="">
                  <div className="data__table">
                    <div className="steps__containt-hader ml-4">
                      <h3 className="title">Map the fields</h3>
                      <p>Map the fields from the data source to the attributes of the standard Ecoprism data requirement.</p>
                    </div>
                    <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0" }} />
                    <div className="revized__container">
                      <div className="data-responsive config-table">
                        <DataTable value={excelfields} responsiveLayout="scroll" className="p-datatable-sm">
                          <Column
                            header="Data Requirement"
                            headerStyle={{ paddingLeft: "20px" }}
                            body={(rowData) => (
                              <div style={{ paddingLeft: "14px", fontSize: "14px" }}>
                                {rowData.key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase())}
                                {rowData.value && <span style={{ color: "red" }}>*</span>}
                                <input type="hidden" value={rowData.key} name="destination[]" data-label={rowData.key} />
                              </div>
                            )}
                          />

                          <Column
                            header="Connector"
                            body={(rowData, options) => (
                              <>
                                <Dropdown
                                  id={`connectord${options.rowIndex}`}
                                  value={selectedConnectors[options.rowIndex] || ""}
                                  options={[
                                    { label: "None", value: "" },
                                    // Add Excel connectors - show "Excel" if only one, or individual names if multiple
                                    ...(selectedExcel.includes("Excel")
                                      ? excelFiles.length === 1
                                        ? [{ label: "Excel", value: "Excel" }]
                                        : excelFiles.map((file) => ({
                                            label: file.connectorName,
                                            value: file.connectorName,
                                          }))
                                      : []),
                                    // Add PDF connectors - show "PDF" if only one, or individual names if multiple
                                    ...(selectedExcel.includes("PDF")
                                      ? pdfFiles.length === 1
                                        ? [{ label: "PDF", value: "PDF" }]
                                        : pdfFiles.map((file) => ({
                                            label: file.connectorName,
                                            value: file.connectorName,
                                          }))
                                      : []),
                                    // Add other connector types
                                    ...selectedExcel
                                      .filter((h) => h !== "Excel" && h !== "PDF")
                                      .map((h) => ({
                                        label: connectorNames[h] || h,
                                        value: h,
                                      })),
                                  ]}
                                  onChange={(e) => {
                                    const updated = [...selectedConnectors];
                                    updated[options.rowIndex] = e.value;
                                    setSelectedConnectors(updated);
                                    document.getElementById(`connector${options.rowIndex}`).value = e.value;

                                    // Clear field selection when connector is set to None
                                    if (e.value === "") {
                                      const updatedOptions = [...selectedOptions];
                                      updatedOptions[options.rowIndex] = "";
                                      setSelectedOptions(updatedOptions);
                                      document.getElementById(`excel${options.rowIndex}`).value = "";
                                    }
                                  }}
                                  placeholder="None"
                                  className="p-inputtext-sm wd-100"
                                  required={rowData.value === true}
                                  style={{ width: "200px", minWidth: "200px", maxWidth: "250px" }}
                                  disabled={!!defaultValues[options.rowIndex]}
                                />
                                <input type="hidden" id={`connector${options.rowIndex}`} value="None" name="connectors[]" />
                              </>
                            )}
                          />
                          <Column
                            header="Field in Data Source"
                            body={(rowData, options) => (
                              <>
                                <Dropdown
                                  id={`dropdown${options.rowIndex}`}
                                  inputId={`dropdown${options.rowIndex}`}
                                  name="excelHeaderss[]"
                                  value={selectedOptions[options.rowIndex] || ""}
                                  options={
                                    // Check if selected connector is "Excel" (single file) or one of the specific Excel connector names
                                    selectedConnectors[options.rowIndex] === "Excel" && excelFiles.length === 1
                                      ? [
                                          { label: "None", value: "" },
                                          ...(individualExcelHeaders[excelFiles[0].connectorName] || []).map((h) => ({
                                            label: h,
                                            value: h,
                                            disabled: selectedOptions.includes(h) && selectedOptions[options.rowIndex] !== h,
                                          })),
                                        ]
                                      : excelFiles.some((file) => file.connectorName === selectedConnectors[options.rowIndex])
                                      ? [
                                          { label: "None", value: "" },
                                          ...(individualExcelHeaders[selectedConnectors[options.rowIndex]] || []).map((h) => ({
                                            label: h,
                                            value: h,
                                            disabled: selectedOptions.includes(h) && selectedOptions[options.rowIndex] !== h,
                                          })),
                                        ]
                                      : selectedConnectors[options.rowIndex] === "PDF" || pdfFiles.some((file) => file.connectorName === selectedConnectors[options.rowIndex])
                                      ? [
                                          { label: "None", value: "" },
                                          ...(Array.isArray(pdffields) ? pdffields : []).map((h) => ({
                                            label: disambiguateSourceLabel(h, pdfSourceLabels, pdffields),
                                            value: h,
                                            disabled: selectedOptions.includes(h) && selectedOptions[options.rowIndex] !== h,
                                          })),
                                        ]
                                      : selectedConnectors[options.rowIndex] === "Azure Table Storage"
                                      ? [
                                          { label: "None", value: "" },
                                          ...(Array.isArray(azureTableStoragefields) ? azureTableStoragefields : []).map((h) => ({
                                            label: h,
                                            value: h,
                                            disabled: selectedOptions.includes(h) && selectedOptions[options.rowIndex] !== h,
                                          })),
                                        ]
                                      : selectedConnectors[options.rowIndex] === "API"
                                      ? [
                                          { label: "None", value: "" },
                                          ...(Array.isArray(apifields) ? apifields : []).map((h) => ({
                                            label: h,
                                            value: h,
                                            disabled: selectedOptions.includes(h) && selectedOptions[options.rowIndex] !== h,
                                          })),
                                        ]
                                      : [{ label: "None", value: "" }]
                                  }
                                  onChange={(e) => excelH(e.value, options.rowIndex)}
                                  placeholder="Field Name"
                                  className="p-inputtext-sm wd-100"
                                  required={rowData.value === true}
                                  style={{ width: "250px", minWidth: "200px", maxWidth: "350px" }}
                                  disabled={!selectedConnectors[options.rowIndex] || !!defaultValues[options.rowIndex]}
                                />
                                <input type="hidden" id={`excel${options.rowIndex}`} value={selectedOptions[options.rowIndex] || ""} name="excelHeaders[]" data-label={rowData.key} />
                                <div className="d-flex justify-content-end mt-2">
                                  <Button className="refresh-cta d-flex align-items-center" type="button" onClick={() => handleOpenDefaultModal(rowData, options.rowIndex)}>
                                    {defaultValues[options.rowIndex] ? "✓ Edit Default Value" : "+ Add Default Value"}
                                  </Button>
                                </div>
                                {defaultValues[options.rowIndex] && (
                                  <div style={{ fontSize: "12px", color: "#407775", marginTop: "4px", textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "8px" }}>
                                    <span>Default: {defaultValues[options.rowIndex]}</span>
                                    <MdClose
                                      onClick={() => {
                                        // Remove default value
                                        setDefaultValues((prev) => {
                                          const newValues = { ...prev };
                                          delete newValues[options.rowIndex];
                                          return newValues;
                                        });
                                        
                                        // Clear the selected option
                                        const updatedOptions = [...selectedOptions];
                                        updatedOptions[options.rowIndex] = "";
                                        setSelectedOptions(updatedOptions);
                                        
                                        // Update hidden input
                                        if (document.getElementById(`excel${options.rowIndex}`)) {
                                          document.getElementById(`excel${options.rowIndex}`).value = "";
                                        }
                                        
                                        toast.success("Default value removed successfully!");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        color: "#dc3545",
                                        fontSize: "18px",
                                        transition: "all 0.2s",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "scale(1.2)";
                                        e.currentTarget.style.color = "#a71d2a";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "scale(1)";
                                        e.currentTarget.style.color = "#dc3545";
                                      }}
                                      title="Remove default value"
                                    />
                                  </div>
                                )}
                              </>
                            )}
                          />
                        </DataTable>
                      </div>
                    </div>
                  </div>
                  <div className="next__previous-buttons pl-4">
                    <div className="d-flex gap-3">
                      <Button className="outline-btn" variant="outlined" onClick={handleBack}>
                        Back
                      </Button>
                      <Button 
                        variant="contained" 
                        color="primary" 
                        className="next-button" 
                        onClick={handleNext}
                        disabled={
                          // Check if all required fields are either mapped or have default values
                          excelfields.some((field, index) => {
                            const isRequired = field.value === true;
                            const selectedValue = selectedOptions[index];
                            const hasDefaultValue = defaultValues[index] && defaultValues[index].trim() !== "";
                            // Field is invalid if it's required and has neither selection nor default value
                            return isRequired && (!selectedValue || selectedValue === "") && !hasDefaultValue;
                          })
                        }
                      >
                        Next
                      </Button>
                    </div>
                    <div class="ab"></div>
                  </div>
                </div>
              )}

              {/* Step 5 */}
              {activeStep === 4 && (
                <div ref={containerRef}>
                  <div className="revized__containt-header">
                    <h3 className="title">Review data connection</h3>
                    <p>Review your data connection ensuring seamless integration and optimal performance</p>
                  </div>
                  <div className="revized_second_steps__container">
                    <div class="finish">
                      <p>
                        <strong>ESG Reporting Unit:</strong> {topic}
                      </p>
                      <p>
                        <strong>Site:</strong> {sitelocation1}
                      </p>
                      <p>
                        <strong>Owner:</strong> {username}
                      </p>

                      <p>
                        <span className="me-2">
                          <strong>Data Frequency:</strong> <span style={{ color: "red" }}>*</span>
                        </span>
                        <Dropdown value={dataFrequency} options={frequencyOptions} onChange={(e) => setDataFrequency(e.value)} placeholder="Select Frequency" className="p-inputtext-sm" style={{ width: "25%" }} required />
                      </p>
                    </div>
                    <div className="steps__container survey-form">
                      <div className="data-responsive">
                        <DataTable
                          value={[
                            // Add individual Excel connectors - show "Excel" if only one, or individual names if multiple
                            ...(selectedExcel.includes("Excel")
                              ? excelFiles.length === 1
                                ? [
                                    {
                                      id: `excel_0`,
                                      connector: "Excel",
                                      connectorName: "Excel",
                                      fileName: excelFiles[0].fileName,
                                      fieldCount: Array.isArray(selectedConnectors) ? selectedConnectors.filter((item) => item === "Excel").length : 0,
                                    },
                                  ]
                                : excelFiles.map((file, index) => ({
                                    id: `excel_${index}`,
                                    connector: "Excel",
                                    connectorName: file.connectorName,
                                    fileName: file.fileName,
                                    fieldCount: Array.isArray(selectedConnectors) ? selectedConnectors.filter((item) => item === file.connectorName).length : 0,
                                  }))
                              : []),
                            // Add other connector types (non-Excel)
                            ...selectedExcel
                              .filter((connector) => connector !== "Excel")
                              .map((connector, index) => ({
                                id: `other_${index}`,
                                connector,
                                connectorName: connectorNames[connector] || "",
                                fieldCount: Array.isArray(selectedConnectors) ? selectedConnectors.filter((item) => item === connector).length : 0,
                              })),
                          ]}
                          className="p-datatable-sm"
                          responsiveLayout="scroll"
                        >
                          <Column field="connectorName" header="Data Connector" headerStyle={{ paddingLeft: "20px" }} body={(rowData) => <div style={{ paddingLeft: "14px" }}>{rowData.connectorName || rowData.connector}</div>} />
                          <Column field="connector" header="Connector Type" />
                          <Column field="fieldCount" header="No of Fields" />
                        </DataTable>
                      </div>
                    </div>
                    <div className="next__previous-buttons">
                      <div className="d-flex">
                        <Button
                          onClick={handleBack}
                          variant="outlined"
                          size="medium"
                          className="outline-btn"
                          sx={{
                            color: "#000",
                            marginRight: "15px",
                            width: "120px",
                            height: "41px",
                            borderRadius: "10px",
                          }}
                        >
                          Back
                        </Button>
                        <Button
                          className="next-button"
                          onClick={handleSubmit}
                          variant="contained"
                          size="medium"
                          disabled={!dataFrequency}
                          sx={{
                            color: "#fff",
                            backgroundColor: "#407775",
                            width: "120px",
                            height: "41px",
                            borderRadius: "10px",
                          }}
                        >
                          Save
                        </Button>
                        {/* <Button onClick={handleCancel} variant="outlined" size="medium" className="outline-btn" sx={{ 'color' : '#000', marginLeft :'20px', position: 'relative', width: '120px', height: '41px', borderRadius: '10px' }}>Cancel</Button> */}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 6 */}
              {activeStep === 5 && (
                <div>
                  <div className="steps__containt-hader ml-4">
                    <h3 className="title">Data connection</h3>
                    <p>The connection has been established and is now accessible in the configuration list</p>
                  </div>
                  <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0" }} />
                  <div className="steps__container">
                    <div class="col-md-3"></div>
                    <div class="finish1">
                      <p>Connection created successfully</p>
                      {activeStep === steps.length && (
                        <Paper className="finish" square elevation={0} sx={{ p: 3 }}>
                          {/* <Typography>All steps completed - you&apos;re finished</Typography> */}
                          <Button
                            sx={{
                              color: "#fff",
                              backgroundColor: "#407775",
                              width: "120px",
                              height: "41px",
                              borderRadius: "10px",
                            }}
                            onClick={handleReset}
                            style={{ mt: 1, mr: 1 }}
                          >
                            <Link to="/allconfiguration" className="btn btn-primary config-btn">
                              All Configurations
                            </Link>
                          </Button>
                        </Paper>
                      )}
                    </div>
                    <div class="col-md-3"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
          </div>
        </div>
        <Modal show={showDefaultModal} onHide={handleCloseDefaultModal} centered className="custom-modal-width reports-modal add-default-value-modal">
          <Modal.Header className="justify-content-between">
            <Modal.Title>Add Default Value</Modal.Title>
            <Button variant="link" className="close-modal-button" onClick={handleCloseDefaultModal} style={{ padding: "0", minWidth: "0" }}>
              <IoIosCloseCircleOutline style={{ color: "white", fontSize: "24px" }} />
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <label className="formlable">Data Requirement</label>
                <p style={{ marginTop: "8px" }}>{currentDefaultRow ? currentDefaultRow.key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase()) : ""}</p>
              </div>
              <div style={{ flex: 1 }}>
                <label className="formlable">Default Value</label>
                <input type="text" value={defaultValue} onChange={(e) => setDefaultValue(e.target.value)} placeholder={currentDefaultRow ? currentDefaultRow.key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase()) : ""} className="form-control" />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="outline-btn" variant="outlined" onClick={handleCloseDefaultModal}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" className="next-button" onClick={handleSaveDefaultValue}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
}
